import { Comment } from "app/shared/model/app.model";
import { Self } from "app/shared/model/link.model";
import { AppStateService } from "../../core/services/app-state.service";
import { NoteComment } from "../../notes/shared/note.model";
import { ReminderComment } from "../../reminders/reminder.model";

export interface CommentEntity {
	noteComments?: NoteComment[];
	reminderComments?: ReminderComment[];
	_links: Self;
}

export class CommentEntity {
	static getComments(entity: CommentEntity) {
		return (entity.noteComments || entity.reminderComments)!;
	}

	static newComment = () => ({
		createdBy: { id: AppStateService.currentUser!.id }
	}) as Comment;
}

export class CommentEntityMetadata {
	type: string;
	newCommentUrl: string;
	projection: string;
	entityHref: string;

	constructor(private commentEntity: CommentEntity) {
		if (commentEntity.noteComments) {
			this.type = 'note';
			this.newCommentUrl = '/api/noteComments';
			this.projection = 'noteCommentProjection';
		}
		else {
			this.type = 'reminder';
			this.newCommentUrl = '/api/reminderComments';
			this.projection = 'reminderCommentProjection';
		}

		this.entityHref = commentEntity._links.self.href;
	}
}